import { useEffect } from 'react';
import { useTelephonyStore } from '../store/telephonyStore';

/**
 * Whether the current user has an active telephony seat (can see calls + call).
 * Multi-seat: access is driven by the `telephony_seats` table, configurable in
 * Réglages → Postes téléphonie. Loads the seat once on first use.
 */
export function useCanUseTelephony(): boolean {
  const canUse = useTelephonyStore((s) => s.canUse);
  const seatLoaded = useTelephonyStore((s) => s.seatLoaded);
  const loadSeat = useTelephonyStore((s) => s.loadSeat);

  useEffect(() => {
    if (!seatLoaded) void loadSeat();
  }, [seatLoaded, loadSeat]);

  return canUse;
}
